import React, { Component } from 'react';
import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { setVariable, getRatings } from '../../store/ratings/actions';
import LoadingOverlay from 'react-loading-overlay';
import DateRange from '../../Components/DateRange';
import { loaderstyle } from '../../config';
import Searchbar from '../../Components/Searchbar';
import RatingsTable from './RatingsTable';
import RatingDateRange from './RatingDatePicker'

class Ratings extends Component {
    state = {
        dateActive: false
    };

    componentDidMount() {
        if(!this.props.autoSearched) {
            this.search({ resetPage: true });
        }
    }

    search = () => {
        this.props.ratings({ resetPage: true });
    };

    setVariable = e => {
        this.props.setVariable(e.target.value);
    };

    render() {
       
        return (
            <div className="wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="page-title">
                        <div className="page-title-heading">
                            <h1>
                                Ratings
                            </h1>
                        </div>
                        <div className="page-title-actions">
                            {/* Rating Page Header: searching fields */}
                            <form onSubmit={e => e.preventDefault()}>
                                {/* Date Range */}
                               <RatingDateRange 
                                    from={this.props.date.from}
                                    to={this.props.date.to}
                               />

                                {/*<DateRange
                                    from={this.props.date.from}
                                    to={this.props.date.to}
                                    toggle={this.toggleDateRangeClasses}
                                    classes={dateClasses}
                                    onDateChange={this.props.setDate}
                                />*/}

                                <Searchbar 
                                    label="Search"
                                    value={this.props.variable}
                                    placeholder="Booking No., Name, Email, Phone, Trip No."
                                    onChange={this.setVariable}/>

                                <div className="form-field">
                                    <Btn
                                        className="btn simple small"
                                        onClick={this.search}
                                    >
                                        Search
                                    </Btn>
                                </div>
                            </form>
                        </div>
                    </div>
                    <hr />

                    <LoadingOverlay
                        active={this.props.loading_search}
                        text="Loading..."
                        spinner
                        styles={loaderstyle}>
                        <RatingsTable />
                    </LoadingOverlay>
                    
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    date: state.ratings.searchOptions.date,
    loading_search: state.ratings.loading_search,
    variable: state.ratings.searchOptions.variable,
    autoSearched: state.ratings.autoSearched,
});

const mapDispatchToProps = dispatch => ({
    ratings: bindActionCreators(getRatings, dispatch),
    setVariable: bindActionCreators(setVariable, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Ratings);
